// Libraries
import { ReactNode } from 'react';

// MUI
import Button from '@mui/material/Button';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material';

// Common
import { AIconButtonBaseProps } from '../../common/buttons';

const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '100px',
    color: 'black',
    minWidth: '36px',
    padding: '6px',
}));

export interface ADefaultIconButtonProps extends AIconButtonBaseProps {
    icon: ReactNode;
    tooltip: NonNullable<React.ReactNode>;
}

export default function ADefaultIconButton(props: ADefaultIconButtonProps) {
    const { icon, tooltip, ...buttonProps } = props;

    return (
        <Tooltip title={tooltip}>
            <span>
                <StyledButton {...buttonProps} variant='text'>
                    {icon}
                </StyledButton>
            </span>
        </Tooltip>
    );
}
